import axios from '../../axios'
import router from '@/router'
import store from "../store";
// import { getAuth, RecaptchaVerifier, signInWithPopup, GoogleAuthProvider, signInWithPhoneNumber } from "firebase/auth";

export default {
  async init({ commit }, accessToken) {
    try {
      if (localStorage.accessToken) {
        let { data } = await axios.get('auth/user')
        commit('SET_BEARER', accessToken)
        store.dispatch('lists/getListMenu');
        commit("SET_USER", data.message);

        let user_data = {
          role_id: data.message.roles[0].role_id,
          user_name: data.message.names,
          numberId: data.message.numberId,
          email: data.message.email,
          id: data.message.id,
        }

        localStorage.user_session = JSON.stringify(user_data)

        if (router.currentRoute.path === '/login') {
          router.push(router.currentRoute.query.to || '/')
        }
      } else {
        if (router.currentRoute.path !== '/login') {
          router.push(router.currentRoute.query.to || '/login')
        }
      }
    } catch (error) {
      if (router.currentRoute.path !== '/login') {
        router.push(router.currentRoute.query.to || '/login')
      }
    }
  },
  async login({ commit }, user) {
    let { data } = await axios.post('auth/login', {
      email: user.email,
      password: user.password,
      remember_me: user.remember_me,
    })
    if (data.success == 1) {
      await delete axios.defaults.headers.common["Authorization"];
      axios.defaults.headers.common['Authorization'] = await `Bearer ${data.token}`
      let userData = await axios.get('auth/user')
      const usr = userData.data.message
      if (usr.two_factor_atutentucation == 1) {
        await delete axios.defaults.headers.common["Authorization"];
        await store.dispatch("auth/phoneValidate", {'usr':usr,'data':data});
      } else {
        localStorage.accessToken = data.token
        axios.defaults.headers.common['Authorization'] = await `Bearer ${data.token}`
        await commit('SET_BEARER', data.token)
        await store.dispatch("auth/init", data.token);
      }

    } else {
      router.push(router.currentRoute.query.to || '/login')
    }
  },

  // phoneValidate({ commit }, form) {
  //   const {usr, data} = form
  //   const auth = getAuth();
  //   const phoneNumber = usr.phone;
  //   const appVerifier = window.recaptchaVerifier;
  //   signInWithPhoneNumber(auth, phoneNumber, appVerifier)
  //     .then((confirmationResult) => {
  //       window.confirmationResult = confirmationResult;
  //       commit("UPDATE_CODE", true);
  //       localStorage.accessTokenAux = data.token
  //     })
  //     .catch((error) => {
  //       commit("UPDATE_CODE", false);
  //       console.log(error);
  //     });
  // },

  // async codeValidate({ commit }, code) {
  //   confirmationResult.confirm(code).then(async (result) => {
  //     localStorage.accessToken = localStorage.accessTokenAux
  //     await commit("UPDATE_CODE", false);
  //     axios.defaults.headers.common['Authorization'] = await `Bearer ${localStorage.accessToken}`
  //     await commit('SET_BEARER', localStorage.accessToken)
  //     await store.dispatch("auth/init", localStorage.accessToken);
  //   }).catch(async (error) => {
  //     await delete axios.defaults.headers.common["Authorization"];
  //     localStorage.accessToken = null
  //   });
  // },

  // loginWithGoogle({ commit, state }, payload) {
  //   const provider = new GoogleAuthProvider();
  //   const auth = getAuth();
  //   signInWithPopup(auth, provider)
  //     .then(async (result) => {
  //       // This gives you a Google Access Token. You can use it to access the Google API.
  //       const credential = GoogleAuthProvider.credentialFromResult(result);
  //       // The signed-in user info.
  //       const user = result.user;
  //       let { data } = await axios.post('auth/login_email', {
  //         username: user.email
  //       })
  //       localStorage.accessToken = data.accessToken
  //       delete axios.defaults.headers.common["Authorization"];
  //       axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`
  //       commit('SET_BEARER', data.accessToken)
  //       store.dispatch("auth/init", data.accessToken);
  //       router.push(router.currentRoute.query.to || '/')
  //       // IdP data available using getAdditionalUserInfo(result)
  //       // ...
  //     }).catch((error) => {
  //       // Handle Errors here.
  //       const errorCode = error.code;
  //       const errorMessage = error.message;
  //       // The email of the user's account used.
  //       const email = error.customData.email;
  //       // The AuthCredential type that was used.
  //       const credential = GoogleAuthProvider.credentialFromError(error);
  //       // ...
  //     });
  // },

  // loginWithFacebook({ commit, state }, payload) {
  //   // if (state.isUserLoggedIn()) {
  //   //   payload.notify({
  //   //     title: 'Login Attempt',
  //   //     text: 'You are already logged in!',
  //   //     iconPack: 'feather',
  //   //     icon: 'icon-alert-circle',
  //   //     color: 'warning'
  //   //   })
  //   //   return false
  //   // }
  //   const provider = new firebase.auth.FacebookAuthProvider()

  //   firebase.auth().signInWithPopup(provider)
  //     .then((result) => {
  //       // router.push(router.currentRoute.query.to || '/')
  //       // commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
  //     }).catch((err) => {
  //       payload.notify({
  //         time: 2500,
  //         title: 'Error',
  //         text: err.message,
  //         iconPack: 'feather',
  //         icon: 'icon-alert-circle',
  //         color: 'danger'
  //       })
  //     })
  // },
}
